import { httpCreate } from './http';

const http = httpCreate('/shop/api/resell-config');

export const resellConfig = {
	getConfig(params) {
		// if (id) {
		//     return http.get('', { params: {
		//         activityId: id
		//     } })
		// }
		return http.get('', { params: params });
	},
	setConfig(body, params) {
		return http.post('/save', body, { params });
	},
	getStatistics(params) {
		// if (id) {
		//     return http.get('/statistics', { params: {
		//         activityId: id
		//     } })
		// }
		return http.get('/statistics', { params: params });
	},
	selfResell(params) {
		return http.post('/self-resell', params);
	},
};
